import { Component, OnInit, ViewChild , OnDestroy} from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';


import { environment } from '../../../environments/environment';
import { seeds } from '../../seeds/seeds';
import { Hauler } from '../hauler.model';
import { Subscription } from 'rxjs/Subscription';
import { HaulersService } from '../haulers.service';
import { QueryService } from '../query.service';
import { Query } from '../query.model';
import { GeoService } from '../../shared/geo.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-haulers-map',
  templateUrl: './haulers-map.component.html',
  styleUrls: ['./haulers-map.component.css']
})
export class HaulersMapComponent implements OnInit, OnDestroy {
  // inital google maps setting
  zoom = 9;
  lat = 48.864716;
  lng = 2.349014;
  radius = 0;

  query: Query;
  haulers: any[];
  subscription: Subscription;
  subscriptionQuery: Subscription;

  items: Observable<any[]>;


  constructor(
    private haulersService: HaulersService,
    private queryService: QueryService,
    private http: Http,
    private geoService: GeoService
    ) { }

  ngOnInit() {
    this.query = this.queryService.getQuery();
    this.setMapLocation(this.query.location);
    this.radius = this.query.radius;

    this.haulersService.getItems().subscribe( (haulers) => this.haulers = haulers);

    this.subscription = this.haulersService.haulersChanged
      .subscribe(
        (haulers: Hauler[]) => {
          this.haulers = haulers;
        });

    // this.haulers = this.haulersService.getHaulers();

    this.subscriptionQuery = this.queryService.queryChanged
        .subscribe(
          (query: Query) => {
            this.query = query;
            this.radius = query.radius;
            this.setMapLocation(query.location);
          }
        );
  }


  setMapLocation(location) {
    this.geoService.getLocation(location)
        .then((response) => {
          this.lat = response.results[0].geometry.location.lat;
          this.lng = response.results[0].geometry.location.lng;
        })
        .catch((error) => console.error(error));
  }



  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionQuery.unsubscribe();
  }


}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers-map/haulers-map.component.ts